import { FaDumbbell, FaPersonRunning } from "react-icons/fa6";
import { GiTennisCourt, GiCctvCamera } from "react-icons/gi";
import { TbPlayFootball } from "react-icons/tb";
import { LiaSwimmingPoolSolid } from "react-icons/lia";
import { LuParkingSquare } from "react-icons/lu";
import { PiChalkboard } from "react-icons/pi";

import logo from '../Assets/Images/Shriram-wytfield-logo.webp';
import BannerImage from "../Assets/Images/Shriram-wytfield-banner.webp";
import FloorPlan0 from '../Assets/Images/Shriram-wytfield-floor-plan-2bhk.webp';

import Gallery1 from '../Assets/Images/Shriram-wytfield-gallery1.webp';
import Gallery2 from '../Assets/Images/Shriram-wytfield-gallery2.webp';
import Gallery3 from '../Assets/Images/Shriram-wytfield-gallery3.webp';
import Virtual from '../Assets/Images/Shriram-wytfield-virtual.webp';
import map from '../Assets/Images/Shriram-wytfield-map.webp';

const headerData = {
    propertylogo: logo,
    logoalt: "logo",
    pageUrl: "http://shriramproperties.in/shriram-wytfield/"
}
const formField = {
    GtmId:"GTM-MLNVT6TB",
    gtmProjectName :"ShriramWYTField",
    EmailProjectName: "Shriram WYTField",
    allMails:["markctkind@gmail.com", "dhinesh@markanthony.co.in", "santhoshrajan@markanthony.co.in"]
}
const bannerData = {
    bgimage: BannerImage,
    title: "NEW LAUNCH",
    projectName: "Shriram WYTField Phase 2",
    location: "At  Budigere Cross",
    developer: "By Shriram Properties",
    detailsone: "Land Parcel",
    landParcel: "11.5 Acres",
    detailstwo:"Total Units",
    totalUnits:"1200 Units ",
    detailsthree: "Structure",
    typology: "2B + G + 14 Floors",
    
    highlights: [
 "Vaastu Compliant Homes",
        "Special Offers On Spot Booking",
        "World Class Amenities"
    ],
    investmentOpportunity: "Excellent Investment Opportunity !!",
    apartmentStarts: "Premium Apartments  Start From",
    startPrice: " 60 Lacs*",
    reasonsToConsider: [
        "Manipal hospital - 25 Mins",
       "Orion Uptown Mall - 9 Mins",
        "Byapanahalli Metro Staton - 25 Mins"
        
        
    ],
    whatsappLink: `https://api.whatsapp.com/send?phone=+918431362126&text=Hi, I am interested in ${formField.EmailProjectName}. Can you share me all details`,
    phoneNumber: "+91-8951505394",
    phoneLink: "tel:89515 05394"
};

const propertyData = {
    "heading": "Shriram WYTField Phase 2",
    "details": {
        "building": {
            "title": "Building",
            "description": "Premium Apartments  "
        },
        "location": {
            "title": "Location",
            "description": "At  Budigere Cross"
        },"bedrooms":{
            "title": "Bedroom",
            "description": "2 BHK Apartments "
        }
       ,
        "possession": {
            "title": "Possession",
            "description": "Aug 2027*"
        },
        "dimension": {
            "title": "Dimension",
            "description": "735 - 780 sq.ft ."
        },
        "price": {
            "title": "Price",
            "description": "₹60 Lacs**"
        }
    }
}


const floorPlans = [
    {
        type: "2 BHK Apartments",
        area: "735 - 780 sq.ft ",
        price: "Starting ₹ 60 Lacs**",
        image: FloorPlan0, 
    },   
   



];

const highlightsData = [
    [
        " Located near Budigere Cross", 
        " Only 15 minutes away from Whitefield", 
        " 40+ awe-inspiring amenities", 
        " Large open spaces", 
        " Residences that match your needs", 
       
      
    ],
    [
        " Two big clubhouses", 
        " Rooftop swimming pool", 
        " Amphitheater", 
        " Club House", 
        " Landscaped gardens", 
      
    
      
    ],
    [
        " Smartly designed homes", 
        " Resort-like environment", 
        " Privacy and exclusivity", 
        " Environmentally friendly homes", 
        " 1200 luxurious units",
        " RERA approved", 
    ]
];

const amenitiesData = [
    { icon: <FaDumbbell className="text-5xl" />, name: "Gym" },
    { icon: <FaPersonRunning className="text-5xl" />, name: "Jogging Track" },
    { icon: <GiTennisCourt className="text-5xl" />, name: "Multipurpose Court" },
    { icon: <TbPlayFootball className="text-5xl" />, name: "Kidsplay Area" },
    { icon: <PiChalkboard className="text-5xl" />, name: "Multipurpose Hall" },
    { icon: <LuParkingSquare className="text-5xl" />, name: "Parking" },
    { icon: <GiCctvCamera className="text-5xl" />, name: "CCTV Security" },
    { icon: <LiaSwimmingPoolSolid className="text-5xl" />, name: "Swimming Pool" }
  ];


  const galleryData = [
    { src: Gallery1, alt: "gallery-photo" },
    { src: Gallery2, alt: "gallery-photo" },
    { src: Gallery3, alt: "gallery-photo" }
];

const locationData = {
    virtualTour: {
      heading: "Virtual Tour",
      imageSrc: Virtual
    },
    locationMap: {
      heading: "Location Map",
      imageSrc: map
    },
    nearbyLocations: [
       " Delhi Public School - 20 Mins",
    
     "   Prestige International School - 23 Mins",
   
       " The Brigade School - 40 Mins",
       "Phoenix Market City Mall - 35 Mins",
       "Gopalan Mall - 34 Mins",
   "Brigade Tech Park - 25 Mins",
   
        
        
    ]
  };

const aboutData = {
    title: "About",
    content: [
        {
            heading: "Shriram WYTField Phase 2:",
            paragraph:"We are thrilled to present Shriram Wytfield Phase 2, an exceptional residential venture by Shriram Properties Budigere Cross, situated near Budigere Cross, Whitefield Extension, Bangalore. Conveniently located just a 15-minute drive from Whitefield and 30 minutes away from Kempegowda Airport, it’s a prime location for IT professionals. This BBMP - A Khata certified project offers well-designed 2 BHK homes measuring approximately 735/780 sq.ft onwards, spread across a vast 11.5-acre site within a larger 40-acre township. The Shriram Wytfield project boasts of 9 towers with an elevation of 2B + G + 14 floors and currently has 150 units available. The residences at Shriram Wytfield Phase 2 are thoughtfully designed to combine elegance and functionality, featuring modern architecture, spacious layouts, and high-quality finishes, offering a blend of comfort and style for its residents.",
            paragraph1:"Shriram Wytfield Phase 2, more than just a residential project, is poised to transform urban living with its ‘Townsome Life’ promise. Nestled in the heart of the city, it offers a refreshing environment with 78% of the area dedicated to open spaces. The project features two spacious clubhouses measuring 10,500 sqft respectively, and is equipped with over 40 cutting-edge amenities. These include a rooftop swimming pool, an amphitheater, and a variety of other exciting and future-ready facilities. In essence, Shriram Wytfield is not just a residence, but a commitment to a lifestyle brimming with joy per square foot. We extend a warm welcome to you to join this vibrant community, located in the Shriram Wytfield Whitefield Extension."
        },
       
        {
            heading: "LOCATION ADVANTAGES:",
            paragraph: "Shriram Wytfield Phase 2, located at Budigere Cross in East Bangalore, is a promising residential hub with excellent connectivity to the city’s major employment and industrial areas. It offers a variety of investment options in a serene, eco-friendly environment with 78% open space. The location also provides easy access to tech parks, educational institutions, healthcare facilities, and entertainment hubs, making it an attractive choice for both home seekers and investors. This Shriram Wytfield project, which is an extension of Shriram Wytfield Whitefield, stands as a testament to the quality and commitment of the Shriram group."   },
        
        {

            heading: "ADDITIONAL BENEFITS:",
            subpoints: [
                "1. Modern Amenities: Enjoy a resort-like atmosphere with a swimming pool, clubhouse, gym, and landscaped gardens.", 
                "2. Family-Friendly: Keep the little ones entertained with a dedicated children's play area and reflexology park.", 
                "3. Active Lifestyle: Stay fit with a basketball court, badminton court, jogging track, or explore the outdoors with a cycling track.", 
                "4. Secure Living: 24/7 security with CCTV cameras ensures peace of mind for residents.", 
                "5. Community Vibes: Amphitheater and party areas create opportunities for social gatherings and resident interaction.", 
                "6. Convenience: Covered car parking keeps your vehicle protected from the elements.", 
                "7. Water Efficiency: A potential benefit could be a rainwater harvesting system or RO water purification for sustainable living.", 
                "8. Power Backup: Uninterrupted living with backup power ensures you're never left in the dark.", 
                "9. Waste Management: Proper waste disposal system for a clean and hygienic living environment.", 
                "10. Potential Property Value Growth: Being in a developing area offers the possibility of property value appreciation in the future.", 
                "11. Proximity to Everyday Needs: While details are not confirmed, potential benefits could include nearby schools, hospitals, and grocery stores.", 
                "12. Environmentally Conscious Design: inquire with the developer if the project incorporates any eco-friendly features like rainwater harvesting or energy-efficient lighting.", 
                "13. Reputable Developer: Benefit from the peace of mind that comes with a project by a well-established developer like Shriram Properties.", 
                "14. Spacious Living: The well-designed 2 BHK apartments offer ample space for comfortable living.", 
                "15. Affordability: Compared to established areas, Budigere Cross offers a more attractive price point for homeownership.",           
     
            ],

           
            
        },
        
      
                
            
        
    ]
};

const footerData ={
    agentrera : "",
    projectrera : "Project RERA  - PRM/KA/RERA/1251/446/PR/211206/004573",
    disclaimer : "The content is for information purposes only and does not constitute an offer to avail of any service. Prices mentioned are subject to change without notice and properties mentioned are subject to availability. Images for representation purposes only. This is the official website of authorized marketing partner. We may share data with RERA registered brokers/companies for further processing. We may also send updates to the mobile number/email id registered with us. All Rights Reserved.",

}

export { headerData,formField, bannerData, propertyData, floorPlans, highlightsData, amenitiesData, galleryData, locationData, aboutData, footerData };
